import { render } from "./AboutCars.vue?vue&type=template&id=7c5f3980"
import script from "./AboutCars.vue?vue&type=script&lang=ts"
export * from "./AboutCars.vue?vue&type=script&lang=ts"

import "./AboutCars.vue?vue&type=style&index=0&id=7c5f3980&lang=scss"
script.render = render

export default script